export default "__VITE_ASSET__723a9c2c__"